export default __webpack_public_path__ + "static/media/logo.ba4d3406.png";